module.exports = __webpack_public_path__ + "static/img/item-5.b4dee16e.png";